// 开发者环境：开|关	【注：方便微信小程序发行测试】
const SWITCH_DEVELOPMENT = false

/** S 是否H5端 **/

const IS_H5 = true





/** E 是否H5端 **/

/** S API BaseURL **/
/**
 * 针对微信小程序打包注意如下：（非公众号和H5）
 * 1.如果使用后台一键上传小程序功能此处文件无需更改，直接在后台点击一键上传即可完成上传
 * 2.如果手动上传，则将[baseUrl]替换成对应域名，按照文档完成小程序上传与审核
 * 3.二开注意：如果要使用后台一键上传小程序功能，请在完成二开后打包微信小程序（在uniapp中执行发行-微信小程序，无需手动在微信开发者工具上传）再执行/uniapp下的autoMiniprogram.sh脚本，将打包结果拷贝至对应目录
 * 4.二开注意：如果无需使用后台一键上传小程序功能，按照文档正常完成在uniapp中执行发行-微信小程序后点击上传即可。
 */

const baseURLMap = {
    // 开发环境
    development: 'https://super.muhe.cc',
    // 生产环境
    production: IS_H5 ? location.origin : 'https://super.muhe.cc'
}

const baseURL = SWITCH_DEVELOPMENT ? baseURLMap['development'] : baseURLMap[process.env.NODE_ENV]

/** E API BaseURL **/

module.exports = {
    version: '3.4.1', // 版本号
    baseURL, // API Base URL
    basePath: '/mobile'
}
